import { Static, Type } from '@sinclair/typebox';

export const WidgetAuthorizedDomainSchema = Type.Object({
  widget_authorized_domain_id: Type.Number(),
  domain: Type.String(),
  stripe_apple_pay_registered: Type.Boolean(),
  created_at: Type.Optional(Type.String({ format: 'date-time' })),
});
export type WidgetAuthorizedDomainObject = Static<typeof WidgetAuthorizedDomainSchema>;

const DOMAIN_PATTERN = '^([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,63}$';

export const CreateWidgetAuthorizedDomainRequestSchema = Type.Object({
  domain: Type.String({
    minLength: 4,
    maxLength: 253,
    pattern: DOMAIN_PATTERN,
    title: 'WIDGET_DOMAIN_FIELD',
    placeholder: 'WIDGET_DOMAIN_PLACEHOLDER',
  }),
});
export type CreateWidgetAuthorizedDomainRequestObject = Static<typeof CreateWidgetAuthorizedDomainRequestSchema>;
